import type { HowItWorkItem } from '~/components/pages/directions/how-it-work-section/how-it-works.types'

const HOW_IT_WORK_AUDIOGUIDE: HowItWorkItem = {
    cards: [
        {
            id: 1,
            title: '',
            description:
                '1. Аудиотреки заранее записываются в&nbsp;микрофон и&nbsp;загружаются в&nbsp;аудиогиды',
            alt: 'Запись аудиотреков в микрофон',
            width: 880,
            height: 488,
            filled_image:
                '/assets/images/ui/how-it-work/jpg-png/woman-with-headphones-drawing.png',
            image: '/assets/images/ui/how-it-work/jpg-png/woman-with-headphones.png',
            filled_image_webp:
                '/assets/images/ui/how-it-work/webp/woman-with-headphones-drawing.webp',
            image_webp:
                '/assets/images/ui/how-it-work/webp/woman-with-headphones.webp',
        },
        {
            id: 2,
            title: '',
            description:
                '2. Экскурсантам раздают аудиогиды при входе на&nbsp;экспозицию или в&nbsp;музей',
            alt: 'Экскурсант получает аудиогид',
            width: 880,
            height: 472,
            filled_image:
                '/assets/images/ui/how-it-work/jpg-png/listeners-take-headphones-drawing.png',
            image: '/assets/images/ui/how-it-work/jpg-png/listeners-take-headphones.png',
            filled_image_webp:
                '/assets/images/ui/how-it-work/webp/listeners-take-headphones-drawing.webp',
            image_webp:
                '/assets/images/ui/how-it-work/webp/listeners-take-headphones.webp',
        },
        {
            id: 3,
            title: '',
            description:
                '3. Посетитель слушает экскурсию через динамик или наушники, в&nbsp;соответствии с&nbsp;номерами экспонатов (в&nbsp;автоматическом или ручном режиме)',
            alt: 'Посетитель слушает экскурсию',
            width: 880,
            height: 472,
            filled_image:
                '/assets/images/ui/how-it-work/jpg-png/people-headphones-drawing.png',
            image: '/assets/images/ui/how-it-work/jpg-png/people-headphones.png',
            filled_image_webp:
                '/assets/images/ui/how-it-work/webp/people-headphones-drawing.webp',
            image_webp:
                '/assets/images/ui/how-it-work/webp/people-headphones.webp',
        },
    ],
    video: {
        title: 'Как используется',
        name: 'Как в работе',
        description: 'Аудиогиды для музеев и&nbsp;улицы в&nbsp;руках слушателя',
        width: 248,
        height: 139,
        video_preview:
            '/assets/images/usage/audioguide/jpg-png/in-museum-2.jpg',
        video_preview_webp:
            '/assets/images/usage/audioguide/webp/in-museum-2.webp',
        duration: '0:45',
        link: 'ed64b10278b999b09feab52ad385b0b3',
    },
}

export default HOW_IT_WORK_AUDIOGUIDE
